import React from 'react';
import HomeFeaturedPage from '../templates/Home/Components/Featured';
import HomeTechnologyPage from '../templates/Home/Components/Technology';
import HomePrivateHealthcarePage from '../templates/Home/Components/PrivateHealthcare';
import HomeCrossoverPublicHealthcarePage from '../templates/Home/Components/CrossoverPublicHealthcare';

const options = [
    {
        title: 'Featured',
        href: `?ca=${encodeURI('Featured')}`,
        Component: <HomeFeaturedPage/>,
    },
    {
        title: 'Technology',
        href: `?ca=${encodeURI('Technology')}`,
        Component: <HomeTechnologyPage/>,
    },
    {
        title: 'Private Healthcare',
        href: `?ca=${encodeURI('Private Healthcare')}`,
        Component: <HomePrivateHealthcarePage/>,
    },
    {
        title: 'Crossover / Public Healthcare',
        href: `?ca=${encodeURI('Crossover / Public Healthcare')}`,
        Component: <HomeCrossoverPublicHealthcarePage/>,
    },
];

export {options as HomeOptionsLink};
